<template>
  <div class="Account">
    <div class="panel">
      <div class="content">
        全球青少年生成式
        <br/>
        人工智能跨学科挑战活动
        <br/>
        ——
        <br/>
        Code Quest 2026年选拔赛
      </div>
      <div class="action">
        <login v-if="type == 'login'"></login>
        <login_with_code v-if="type == 'loginWithCode'"></login_with_code>
        <register v-if="type == 'register'"></register>
        <password v-if="type == 'password'"></password>
        <certification v-if="type == 'certify'"></certification>
        <modify_info v-if="type =='modify'"></modify_info>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import MyImage from '@/components/Image.vue';
import Login from '@/components/account/Login.vue'
import LoginWithCode from '@/components/account/LoginWithCode.vue'
import Register from '@/components/account/Register.vue'
import Password from '@/components/account/Password.vue'
import Certification from '@/components/account/Certification.vue'
import ModifyInfo from '@/components/account/ModifyInfo.vue'

export default {
  name: 'Account',
  computed: {
    sideImg() {
      return '/oss/images/account/sideImg.png'
    },
    type () {
      return this.$route.params.type
    }
  },
  components: {
    my_image: MyImage,
    login: Login,
    register: Register,
    login_with_code: LoginWithCode,
    password: Password,
    certification: Certification,
    modify_info: ModifyInfo
  }
}
</script>

<style scoped>
.Account{
  background-image: url('/oss/images/frontpage/header-2025.png');
  background-size: cover;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.panel{
  width: 100%;
  height: 34.0625vw;
  display: flex;
}
.panel .content {
  font-size: 26px;
  font-style: bold;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-align: right;
}
.panel> div {
  flex-basis: 48%;
}
.action {
  /* background: #f5f5f5; */
}

@media (min-width: 320px) and (max-width: 480px) {
  .Account{
    height: 100vh;
  }
  .img{
    display: none;
  }
  .panel{
    width: 100vw;
    height: 100vh;
    display: flex;
  }


}
</style>
